import * as React from 'react'
import { useCallback } from 'react'
import { toast } from '@sales-center/components'
import { bulkDeleteOpps } from '@user/store/opportunity'
import { BulkActionsProps, BulkDelete } from '@user/components/xGrid'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

type Props = BulkActionsProps & { hasPermission: boolean }
export const OpportunityBulkDelete: React.FC<Props> = ({
  selectedRows,
  hasPermission,
}) => {
  const dispatch = useAppDispatch()

  const deleteCallback = useCallback(async () => {
    const ids = [...selectedRows.keys()].map((k) => Number(k))
    const result = await dispatch(bulkDeleteOpps(ids))
    if (bulkDeleteOpps.fulfilled.match(result)) {
      toast.success('Records deleted successfully')
      return true
    } else {
      if (result.payload) toast.error(result.payload.Message)
      return false
    }
  }, [dispatch, selectedRows])

  return (
    <BulkDelete
      recordCount={selectedRows.size}
      saveCallback={deleteCallback}
      hasPermission={hasPermission}
    />
  )
}
OpportunityBulkDelete.displayName = 'OpportunityBulkDelete'
